import React, {Component} from 'react';
import Swiper from 'swiper/dist/js/swiper';

import imgLogoApacheWeb from './tech-stack/logo-apache-web-server-200.png';
import imgLogoBabel from './tech-stack/logo-babel-200.png';
import imgLogoC from './tech-stack/logo-c-200.png';
import imgLogoCSharp from './tech-stack/logo-c-sharp-200.png';
import imgLogoCentOS from './tech-stack/logo-centos-200.png';
import imgLogoCpp from './tech-stack/logo-cpp-200.png';
import imgLogoCSS3 from './tech-stack/logo-css3-200.png';
import imgLogoDebian from './tech-stack/logo-debian-200.png';
import imgLogoEclipse from './tech-stack/logo-eclipse-200.png';
import imgLogoFedora from './tech-stack/logo-fedora-200.png';
import imgLogoGit from './tech-stack/logo-git-200.png';
import imgLogoGithub from './tech-stack/logo-github-200.png';
import imgLogoHtml5 from './tech-stack/logo-html5-200.png';
import imgLogoJava from './tech-stack/logo-java-200.png';
import imgLogoJs from './tech-stack/logo-js-200.png';
import imgLogoMySQL from './tech-stack/logo-mysql-mariadb-200.png';
import imgLogoNginx from './tech-stack/logo-nginx-200.png';
import imgLogoNodejs from './tech-stack/logo-nodejs-200.png';
import imgLogoOracle from './tech-stack/logo-oracle-db-200.png';
import imgLogoPostgreSQL from './tech-stack/logo-postgresql-200.png';
import imgLogoPython from './tech-stack/logo-python-200.png';
import imgLogoReact from './tech-stack/logo-react-200.png';
import imgLogoRedis from './tech-stack/logo-redis-200.png';
import imgLogoSinaWeibo from './tech-stack/logo-sina-weibo-200.png';
import imgLogoUbuntu from './tech-stack/logo-ubuntu-200.png';
import imgLogoWeChat from './tech-stack/logo-wechat-200.svg';
import imgLogoWindows from './tech-stack/logo-windows-200.png';

import './TechStack.css';

export default class TechStack extends Component {

  componentDidMount() {
    new Swiper('.swiper-container-our-tech', {
      // Optional parameters
      speed: 500,
      slidesPerView: 8,
      slidesPerColumn: 2,
      spaceBetween: 40,

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        // when window width is <= 320px
        // when window width is <= 480px
        400: {
          slidesPerView: 4,
          slidesPerColumn: 4,
          spaceBetween: 30
        },
        768: {
          slidesPerView: 5,
          slidesPerColumn: 3,
          spaceBetween: 30
        },
        // when window width is <= 640px
        992: {
          slidesPerView: 6,
          slidesPerColumn: 3,
          spaceBetween: 40
        },
        1120: {
          slidesPerView: 8,
          spaceBetween: 30
        }
      }
    });
  }

  render() {
    return (
        <div className="container-fluid our-tech-container">
          <div className="row">
            <div className="container" id="our-tech-container">
              <div className="row">
                <div className="col-xs-12">
                  <div className="our-tech">技术领域</div>
                  <p>我们始终跟随技术潮流，掌握技术前沿，善于充分、灵活地运用最适合的信息技术，快速解决企业信息化道路上的痛点及难点。</p>
                </div>
                <div className="col-xs-12 our-tech-outer-wrapper">

                  {/* Slider our tech-stack container */}
                  <div className="swiper-container-our-tech">
                    {/* Additional required wrapper */}
                    <div className="swiper-wrapper">
                      {/* Slides */}
                      <div className="swiper-slide">
                        <img src={imgLogoNginx} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoWeChat} alt='WeChat' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoNodejs} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoJs} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoReact} alt='React' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoBabel} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoCSS3} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoHtml5} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoGit} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoGithub} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoApacheWeb} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoCSharp} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoCpp} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoJava} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoEclipse} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoMySQL} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoOracle} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoPostgreSQL} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoPython} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoRedis} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoSinaWeibo} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoC} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoCentOS} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoFedora} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoDebian} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoUbuntu} alt='' />
                      </div>
                      <div className="swiper-slide">
                        <img src={imgLogoWindows} alt='Windows' />
                      </div>
                    </div>

                    {/* navigation buttons */}
                    <div className="swiper-button-prev">
                    </div>
                    <div className="swiper-button-next">
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TechStack.js